<div class="rs-review-rockspoon-plan">
  <div class="rs-review-rockspoon-plan__title rs-review-step">{{'review.rockspoon-plan' | translate}}</div>
  <div *ngIf="selectedPlan" class="rs-review-rockspoon-plan__value">
    <rs-plan-item [plan]="selectedPlan"></rs-plan-item>
  </div>
</div>
